import { defaultFill } from '../utils/constants';
var muiBarChart16 = {
    paths: [
        {
            path: 'M0,1 C0,0.44771525 0.44771525,0 1,0 C1.55228475,0 2,0.44771525 2,1 L2,12 L4,12 L4,7 C4,6.44771525 4.44771525,6 5,6 C5.55228475,6 6,6.44771525 6,7 L6,12 L8,12 L8,5 C8,4.44771525 8.44771525,4 9,4 C9.55228475,4 10,4.44771525 10,5 L10,12 L12,12 L12,3 C12,2.44771525 12.4477153,2 13,2 C13.5522847,2 14,2.44771525 14,3 L14,12 L15,12 C15.5522847,12 16,12.4477153 16,13 C16,13.5522847 15.5522847,14 15,14 L0,14 L0,1 Z',
            fill: defaultFill,
        },
    ],
    title: 'Bar Chart',
    width: 16,
    height: 14,
};
var muiBarChart24 = {
    paths: [
        {
            path: 'M9,10 C9,9.44771525 9.44771525,9 10,9 C10.5522847,9 11,9.44771525 11,10 L11,20 L13,20 L13,6 C13,5.44771525 13.4477153,5 14,5 C14.5522847,5 15,5.44771525 15,6 L15,20 L17,20 L17,2 C17,1.44771525 17.4477153,1 18,1 C18.5522847,1 19,1.44771525 19,2 L19,20 L21,20 C21.5522847,20 22,20.4477153 22,21 C22,21.5522847 21.5522847,22 21,22 L0,22 L0,1 C0,0.44771525 0.44771525,0 1,0 C1.55228475,0 2,0.44771525 2,1 L2,20 L5,20 L5,14 C5,13.4477153 5.44771525,13 6,13 C6.55228475,13 7,13.4477153 7,14 L7,20 L9,20 L9,10 Z',
            fill: defaultFill,
        },
    ],
    title: 'Bar Chart',
    width: 22,
    height: 22,
};
var muiBarChart = {
    base: muiBarChart16,
    smIcon: muiBarChart16,
    lgIcon: muiBarChart24,
};
export { muiBarChart };
//# sourceMappingURL=barChart.js.map